import styled from 'styled-components'

export const Container = styled.div<{ inline?: boolean }>`
  display: ${(p) => (p.inline ? 'inline-block' : 'block')};
  height: 100%;
  width: 100%;
  position: relative;
`
